import SavedViewsMenu from "@common/components/savedViews/SavedViewsMenu";
import { ClientFilteredPageView } from "@common/pageView/useClientFilteredPageView";

export interface SavedViewPickerProps<TColumn extends string> {
    pageView: ClientFilteredPageView<TColumn>;
    isLoading: boolean;
}

// The view menu of a table whose saved views come from useClientFilteredPageView. It goes in the toolbar's view row,
// above the filters, while SavedViewControls holds the buttons that end the filter row.
function SavedViewPicker<TColumn extends string>(props: SavedViewPickerProps<TColumn>) {
    const view = props.pageView;

    return (
        <SavedViewsMenu
            currentViewId={view.currentViewId}
            parentIsLoading={props.isLoading}
            currentFilterData={view.filterData}
            currentDisplayData={view.visibleColumns}
            onViewChange={view.onChangeView}
            onViewSaved={view.onViewSaved}
            onViewDeleted={view.onViewDeleted}
            filterPage={view.page}
            hasFilterOrDisplayDataChanged={view.hasFilterChanged || view.hasDisplayChanged}
        />
    );
}

export default SavedViewPicker;
